import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMdFormActionState } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { DwUserEntity } from '../../../meta-data/app-meta-data.service';
import { ProfileFormService } from '../services/profile-form.service';
import { ProfileInlineEditService } from '../services/profile-inline-edit.service';

export const EDIT_PROFILE_BANNER = 'fitness-profile-banner-edit';
export const STYLE_PROFILE_BANNER = 'fitness-profile-banner-style';

@DwAction({ keyName: EDIT_PROFILE_BANNER, display: 'Edit profile', actionType: DwActionType.formAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class EditProfileBannerAction implements DwActionHandler {
    constructor(private forms: ProfileFormService, private inline: ProfileInlineEditService) {}
    handleAction(state: DwMdFormActionState): Observable<DwActionResult> {
        return requestEditor(state, this.forms, this.inline, 'edit');
    }
}

@DwAction({ keyName: STYLE_PROFILE_BANNER, display: 'Style', actionType: DwActionType.formAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class StyleProfileBannerAction implements DwActionHandler {
    constructor(private forms: ProfileFormService, private inline: ProfileInlineEditService) {}
    handleAction(state: DwMdFormActionState): Observable<DwActionResult> {
        return requestEditor(state, this.forms, this.inline, 'style');
    }
}

function requestEditor(state: DwMdFormActionState, forms: ProfileFormService, inline: ProfileInlineEditService,
    action: 'edit' | 'style'): Observable<DwActionResult> {
    const user = state.formApi.getFormData<DwUserEntity>();
    if (forms.canEdit(user?.UserId)) { inline.bannerAction$.next({ userId: user.UserId, action }); }
    // The header owns editor completion; opening it does not save the banner form.
    return of(Object.assign(new DwActionResult(), { success: false, cancelled: true }));
}
